import { useQuery, UseQueryResult } from 'react-query'

import type { ProjectService } from 'features/project/service'

type ProjectCacheAvailability = {
  available: boolean
}

export const useProjectCacheAvailability = (
  projectService: ProjectService,
  projectId: string,
): UseQueryResult<ProjectCacheAvailability> => {
  return useQuery(
    ['project-cache-availability', projectId],
    () => projectService.getProjectCacheAvailability(projectId),
    {
      enabled: !!projectId,
      refetchOnWindowFocus: false,
      retry: false,
    },
  )
}
